import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import { getUrl } from '~/services/shop/utils';

type Args = {
    signal: AbortSignal | undefined;
    customerId: string | null;
    token: string | null;
};

export default function getUserProfile({ signal, customerId, token }: Args) {
    const url = getUrl('/customers/users/me');

    if (customerId) {
        url.searchParams.append('customerId', customerId);
    }
    return shop
        .get(url, {
            signal,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .json<ShopTypes.UserCustomerResponse>();
}
